/* src/app/chat-widgets/table-card/table-card.component.css */
/*# sourceMappingURL=table-card.component-4LRD2N55.css.map */
